export default Object.freeze({
  // PASSWORD_CHANGE_
  PWD_CHANGE: '비밀번호 변경',
  MUST: '(필수)',
  MUST_NOTICE: '6개월 이상 동일한 비밀번호를 사용하고 있습니다. 운영자 계정 보안을 위해 비밀번호를 반드시 변경 해 주세요.',
  DESCRIPTION_1: '비밀번호는 영문,숫자,특수문자를 조합하여 8~20자리로 설정하셔야 합니다.',
  DESCRIPTION_2: '(10자리 이상 시에는 2종류 이상 조합, 미만 시에는 3종류 모두 조합)',
  DESCRIPTION_3: '특수문자는 !@#$%^&+=-_.() 만 사용 가능합니다.',
  DESCRIPTION_4: '연속적인 숫자나 생일, 전화번호 등 추측하기 쉬운 개인정보 및 아이디와 비슷한 비밀번호는 사용하지 않는 것을 권고합니다.',

  CURRENT_PWD: '현재 비밀번호',
  NEW_PWD: '새 비밀번호',
  NEW_PWD2: '신규 비밀번호',
  NEW_PWD_CONFIRM: '새 비밀번호 확인',
  NEW_PWD_CONFIRM2: '비밀번호 확인',
  NEW_PWD_GUID: '영문,숫자,특수문자를 조합하여 8~20자리로 설정하셔야 합니다.',
  NEW_PWD_ERR_1: '8자리 이상의 비밀번호를 입력 해 주세요.',
  NEW_PWD_ERR_2: '영문,숫자,특수문자 중 2종류 이상 조합하여 입력해주세요.',
  NEW_PWD_ERR_3: '영문,숫자,특수문자를 3종류 모두 조합하여 입력해주세요.',
  NEW_PWD_ERR_4: '!@#$%^&+=-_.() 특수문자만 사용 가능합니다.',
  NEW_PWD_CONFIRM_GUID: '동일한 비밀번호를 입력해 주세요.',
  NEW_PWD_CONFIRM_PASS: '비밀번호가 동일합니다.',
  NEW_PWD_CONFIRM_FAIL: '비밀번호를 다시 확인해 주세요.',

  ERR_CURRENT_PWD_EMPYT: '현재 비밀번호를 입력해 주세요.',
  ERR_NEW_PWD_EMPYT: '새 비밀번호를 입력해 주세요.',
  ERR_NEW_PWD_CONFIRM_EMPYT: '새 비밀번호 확인을 입력해 주세요.',
  ERR_NEW_PWD_LENGTH: '8자리 이상의 비밀번호를 입력해 주세요.',
  ERR_NEW_PWD_LENGTH2: '새 비밀번호를 확인해 주세요.',
  ERR_PWD_REPEAT: '현재 비밀번호와 다른 새 비밀번호를 입력해 주세요.',

  SUCCESS_MSG: '운영자 비밀번호가 변경되었습니다.'
});
